import { createSelector, Selector } from 'reselect';
import { State } from '../../../store/reducers';
import { selectProject } from './project.selector';
import { Project } from '../../../domain/project/Project';

export const selectProjectCurrentCustomPriceListId: Selector<State, Project['customPriceListId']> =
  createSelector([selectProject], (project) => (project ? project.customPriceListId : 'none'));
